
export default function Services() {
  const services = [
    {
      icon: 'ri-building-4-line',
      title: 'ASU Installation & Commissioning',
      description:
        'Complete Air Separation Unit deployment from site evaluation through full-scale production commissioning. Turnkey infrastructure solutions for LOX, LIN, and LAR production facilities.',
      features: ['Site Engineering', 'Turnkey Deployment', 'Production Testing'],
    },
    {
      icon: 'ri-cpu-line',
      title: 'Smart Logistics & AI Supply Chain',
      description:
        'AI-powered demand forecasting, automated inventory management, and intelligent distribution routing. Real-time supply chain optimization across multi-region networks.',
      features: ['AI Forecasting', 'Route Optimization', 'Demand Analytics'],
    },
    {
      icon: 'ri-snowflake-line',
      title: 'Cryogenic Storage & Distribution',
      description:
        'Advanced cryogenic storage terminals, bulk tanker distribution networks, and pipeline supply systems. Export-grade infrastructure for large-scale industrial operations.',
      features: ['Bulk Storage', 'Pipeline Systems', 'Export Terminals'],
    },
    {
      icon: 'ri-ship-line',
      title: 'Port Automation & Maritime Fueling',
      description:
        'Smart port integration with automated cargo logistics, cryogenic maritime fueling operations, and integrated port energy systems for shipping corridors.',
      features: ['Port Integration', 'Maritime LNG', 'Cargo Automation'],
    },
  ];

  return (
    <section id="services" className="bg-gradient-to-b from-stone-200 to-stone-100 py-24 px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-2 gap-16">
        {/* Left - Content */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-1 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-full"></div>
            <span className="text-teal-600 text-sm font-bold tracking-wide uppercase">
              Infrastructure Services
            </span>
          </div>

          <h2 className="text-stone-800 font-black text-4xl leading-tight mb-5">
            Infrastructure-Scale
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500">
              Operations & Smart Logistics
            </span>
          </h2>

          <p className="text-stone-600 text-base leading-relaxed mb-10">
            From ASU deployment to AI-powered supply chain intelligence, SkyForge delivers comprehensive infrastructure services powering global industrial gas production and distribution networks.
          </p>

          {/* Service Cards */}
          <div className="space-y-4">
            {services.map((service, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-stone-50 to-stone-100 border border-stone-200 hover:border-teal-300 rounded-xl p-5 transition-all cursor-pointer hover:shadow-lg"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                    <i className={`${service.icon} text-lg text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-stone-800 font-bold text-base mb-1.5">
                      {service.title}
                    </h3>
                    <p className="text-stone-500 text-sm leading-relaxed mb-3">
                      {service.description}
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {service.features.map((feature, idx) => (
                        <span
                          key={idx}
                          className="bg-teal-100 text-teal-700 text-xs px-3 py-1 rounded-full font-medium"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right - Image */}
        <div className="relative">
          <div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/fa7fa6f94fb5f5e14d9a0d37fce72898.jpg"
                alt="Infrastructure Operations Control Center"
                className="w-full h-[500px] object-cover object-top"
              />
            </div>

            {/* Stats Overlay */}
            <div className="absolute -bottom-6 left-6 right-6 bg-stone-50 border border-stone-200 rounded-2xl p-5 shadow-xl">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <p className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500 text-2xl font-black">
                    5+
                  </p>
                  <p className="text-stone-500 text-xs mt-0.5">ASU Sites</p>
                </div>
                <div className="border-x border-stone-200">
                  <p className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500 text-2xl font-black">
                    AI
                  </p>
                  <p className="text-stone-500 text-xs mt-0.5">Logistics</p>
                </div>
                <div>
                  <p className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500 text-2xl font-black">
                    Global
                  </p>
                  <p className="text-stone-500 text-xs mt-0.5">Network</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
